import Matter from 'matter-js';
import YouTube from 'react-youtube';

import { Entities } from '../../../models';
import noteEntity from '../../entities/note';
import { NOTE_KEYS } from '../../../constants/layout';
import { GARBAGE_THRESHOLD } from '../../../constants/mechanics';
import { getNewY, getNoteDims } from '../../../helpers';

export default (entities: Entities): Entities => {
  const newEntities = entities;
  const { receptor, notes } = entities;
  const { engine, windowDims } = entities.physics;
  const { rhythm, velocity, videoStartTime, videoEndTime } = entities.session;
  const {
    renderedNoteIdx,
    youTubePlayerState,
    startTime,
    videoTime,
    videoDelta,
  } = entities.state;

  // Handle timing synchronization
  if (videoDelta <= 0) return newEntities;

  // Make sure start time set and YouTube background is playing
  if (startTime < 0 || youTubePlayerState !== YouTube.PlayerState.PLAYING)
    return newEntities;

  // Delete old or move active notes
  const endY = windowDims.h + getNoteDims(windowDims).h;
  const receptorY = receptor.getPos().y;
  const noteKeys = Object.keys(notes);

  noteKeys.forEach((key) => {
    const note = notes[key];
    const oldY = note.getPos().y;
    const newY = getNewY(receptorY, note.timing, videoTime, velocity);
    const translation = { x: 0, y: newY - oldY };
    const isGarbage =
      videoTime - note.garbageTime > GARBAGE_THRESHOLD &&
      note.state !== NOTE_KEYS.miss &&
      !note.attemptable;

    if (newY > endY) {
      Matter.Composite.remove(engine.world, note.body);
      delete newEntities.notes[key];
    } else if (!note.state || note.state === NOTE_KEYS.miss || isGarbage)
      Matter.Body.translate(note.body, translation);
  });

  // Add notes based on timing and review start time
  const startY = 0;
  const nextNoteIdx = renderedNoteIdx + 1;

  if (nextNoteIdx < rhythm.timings.length) {
    const newNoteTiming = rhythm.timings[nextNoteIdx];
    const newNoteY = getNewY(receptorY, newNoteTiming, videoTime, velocity);

    if (newNoteTiming < videoStartTime || newNoteTiming >= videoEndTime)
      newEntities.state.renderedNoteIdx = nextNoteIdx;
    else if (newNoteY > startY) {
      const newNote = noteEntity(
        windowDims,
        0,
        newNoteY,
        '',
        '',
        newNoteTiming
      );

      newEntities.notes[nextNoteIdx] = newNote;
      Matter.Composite.add(engine.world, [newNote.body]);
      newEntities.state.renderedNoteIdx = nextNoteIdx;
    }
  }

  return newEntities;
};
